// ─────────────────────────────────────────────
// hooks/useRequests.js
// Fetches and manages pickup requests
// Uses: @supabase/supabase-js (MIT)
// License: MIT (your original IP)
// ─────────────────────────────────────────────

import { useState, useRef } from "react";
import { getAllRequests, getMyRequests } from "../services/supabaseService";

export function useRequests(session, isAdmin) {
  const [reqs, setReqs]               = useState([]);
  const [reqsLoading, setReqsLoading] = useState(false);
  const [reqsError, setReqsError]     = useState(null);
  const loadingRef                    = useRef(false);

  async function loadReqs() {
    if (!session || loadingRef.current) return;
    loadingRef.current = true;
    setReqsLoading(true);
    setReqsError(null);
    try {
      const data = isAdmin
        ? await getAllRequests()
        : await getMyRequests(session?.user?.id);
      setReqs(data || []);
    } catch (e) {
      setReqsError(e?.message || "Failed to load requests");
      setReqs([]);
    } finally {
      setReqsLoading(false);
      loadingRef.current = false;
    }
  }

  return { reqs, setReqs, reqsLoading, reqsError, loadReqs };
}
